<template>
    <div class="view-catalog-infos">
      <div class="headline">
        <h4>
          Descubra uma maneira mais fácil e organizada de explorar nossos produtos!
        </h4>
        <p>Com a nova função de catálogo, sua experiência de compra será ainda mais incrível.</p>
        <vs-alert
            title="Aviso"
            active="true"
            class="mb-8 mt-8"
            color="warning"
        >
          Preencha os dados abaixo, e nossa equipe irá entrar em contato para mais informações.
        </vs-alert>
      </div>
      <div class="contact-form">
        <div class="vx-row mb-2">
          <div class="vx-col w-full">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-user"
              icon-no-border
              label-placeholder="Nome"
              v-model="formData.full_name"
              v-validate="'required'"
              name="nome"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('nome')"
            >
              {{ errors.first('nome') }}
            </span>
          </div>
        </div>

        <div class="vx-row mb-2">
          <div class="vx-col w-full">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-phone"
              icon-no-border
              label-placeholder="Telefone"
              v-model="formData.phone_number"
              v-mask="phoneNumberMask"
              v-validate="'required|min:14'"
              name="telefone"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('telefone')"
            >
              {{ errors.first('telefone') }}
            </span>
          </div>
        </div>

        <div class="vx-row mt-5">
          <div class="vx-col w-full">
            <vs-button class="mr-3 mb-2" @click="submitForm" :disabled="!isFormValid">Enviar</vs-button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import supportEmail from '@/http/requests/supportEmail'

export default {
  data() {
    return {
      isMounted: false,
      formData: {
        full_name: '',
        phone_number: ''
      }
    }
  },
  computed: {
    isFormValid() {
      return !this.errors.any()
    },
    phoneNumberMask() {
      if (this.formData.phone_number.startsWith('0800') || this.formData.phone_number.startsWith('(08) 00')) {
        return '#### ### ####'
      }
      else if (this.formData.phone_number.startsWith('800') || this.formData.phone_number.startsWith('(80) 0')) {
        return '### ### ####'
      }
      return ['(##) ####-####', '(##) #####-####']
    }
  },
  methods: {
    submitForm() {
      const formData = this.$_.cloneDeep(this.formData);

      this.$validator.validateAll().then(result => {
        if (result) {
          supportEmail.sendBuyCatalogEmail(formData).then(() => {
            this.formData = {
              full_name: '',
              phone_number: ''
            }

            this.errors.clear()
            this.$validator.reset()

            this.$vs.notify({
              color: 'success',
              title: 'Sua mensagem foi enviada com sucesso!',
              text: 'Em breve nossa equipe irá entrar em contato!'
            })
            this.$emit('isActiveFalse')
          }).catch((error) => { console.error(error) })
        }
      })
    }
  },
  async mounted() {
    this.isMounted = true;
  }
}
</script>

<style lang="scss">
  .view-catalog-infos {
    .con-vs-alert {
      height: auto!important;
    }
  }
</style>